import { useState } from 'react';

export type UseToggleReturn = [boolean, () => void];

export function useToggle(defaultState = false): UseToggleReturn {
  const [state, setState] = useState<boolean>(defaultState);

  const handleStateChange = (): void => setState((state) => !state);

  return [state, handleStateChange];
}
